import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { RootState } from '~/biz/store/types'
import { resetRedirect } from '~/biz/store/route/actions'

type RouteHooksProps = {
  resetModal: () => void
}

const RouteHooks: React.FC<RouteHooksProps> = ({ resetModal }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const currentRedirect = useSelector((state: RootState) => state.route.currentRedirect)
  const redirectState = useSelector((state: RootState) => state.route.redirectState)

  const whenSwitchRoute = useCallback(() => {
    window.scrollTo(0, 0)
    dispatch(resetRedirect())
  }, [dispatch])

  useEffect(() => {
    whenSwitchRoute()
    if (resetModal) {
      resetModal()
    }
  }, [location, resetModal, whenSwitchRoute])

  if (currentRedirect === null) {
    return null
  }

  return <Navigate to={currentRedirect} replace state={redirectState} />
}

export default RouteHooks
